import request from '@/utils/request'

export const getBatchmanageList = ({ page, size, keywords: BatchmanageName, productionRecordId }) => {
  return request({
    url: `/trace/batchmanage/${page}/${size}`,
    params: {
      BatchmanageName,
      productionRecordId
    }
  })
}

export const getBatchmanageProductList = ({ page, size, keywords: BatchmanageName, productId }) => {
  return request({
    url: `/trace/batchmanage/${productId}/${page}/${size}`,
    params: {
      BatchmanageName
    }
  })
}

export const getBatchmanageProduct = (productId) => {
  return request({
    url: `/trace/batchmanage/product/${productId}`
  })
}

export const postBatchmanageEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/batchmanage',
    data
  })
}

export const putBatchmanageAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/batchmanage',
    data
  })
}

export const getBatchmanageDetail = (id) => {
  return request({
    url: `/trace/batchmanage/${id}`
  })
}

export const deleteBatchmanageDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/batchmanage/${id}`
  })
}

export const delBatchmanageList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/batchmanage/all',
    data
  })
}

// 批次控制点
// 批次控制点列表
export const getBatchControlpointList = ({ page, size, batchId }) => {
  return request({
    url: `/trace/batch/controlpoint/${batchId}/${page}/${size}`
  })
}
// 控制点列表
export const getControlpointList = ({ page, size, productId }) => {
  return request({
    url: `/trace/batch/controlpoint/point/${productId}/${page}/${size}`
  })
}

export const postBatchControlpointEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/batch/controlpoint',
    data
  })
}

export const putBatchControlpointAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/batch/controlpoint',
    data
  })
}

export const getBatchControlpointDetail = (id) => {
  return request({
    url: `/trace/batch/controlpoint/${id}`
  })
}

export const deleteBatchControlpointDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/batch/controlpoint/${id}`
  })
}

export const delBatchControlpointList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/batch/controlpoint/all',
    data
  })
}

// 批次检查项
// 批次检查项列表
export const getBatchCheckList = ({ page, size, batchId }) => {
  return request({
    url: `/trace/batch/check/${batchId}/${page}/${size}`
  })
}
// 检查项列表
export const getCheckitemsList = ({ page, size, productId }) => {
  return request({
    url: `/trace/batch/check/items/${productId}/${page}/${size}`
  })
}

export const postBatchCheckEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/batch/check',
    data
  })
}

export const putBatchCheckAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/batch/check',
    data
  })
}

export const getBatchCheckDetail = (id) => {
  return request({
    url: `/trace/batch/check/${id}`
  })
}

export const deleteBatchCheckDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/batch/check/${id}`
  })
}

export const delBatchCheckList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/batch/check/all',
    data
  })
}
